import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import { BLUE_COLOR, rolColor } from '../../../../constants/ColorsConst';
import * as CONST from '../../../../constants/FieldsConst';
import { formatDNI, textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { generosEnum } from '../../../../widgets/fields/GenerosField';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allUsuariosAction,
  deleteUsuariosAction,
  setActivoUsuariosAction,
} from '../UsuariosAction';
import { PARAMS_USUARIOS } from '../UsuariosReducer';
import { rolesArray } from './SelectFieldRoles';

export const NameComponent = styled.p`
  cursor: pointer;
  font-weight: bold;
  color: ${({ color }) => color ?? BLUE_COLOR};
  margin: 0;
  text-transform: uppercase;
  margin-right: ${({ mr }) => mr ?? '2em'};

  &:hover {
    color: purple;
  }
`;

let intervalSearch = null;

const ListadoUsuarios = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);

  const [rows, setRows] = React.useState([]);

  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [loadingDelete, setLoadingDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (usuariosStore.all && usuariosStore.all.length === 0) {
        await allUsuariosAction(dispatch, usuariosStore.params);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      await allUsuariosAction(dispatch, usuariosStore.params);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuariosStore.params]);

  React.useEffect(() => {
    const fetchData = () => {
      const lista = usuariosStore.all.map((el) => {
        const entidades = el.entidades.map((ent) => {
          if (ent.perfiles.length > 0) {
            const perfiles = ent.perfiles.map((per) => per.perfil);
            return {
              entidad: ent.entidad,
              perfiles,
            };
          } else {
            return {
              entidad: ent.entidad,
              perfiles: [],
            };
          }
        });

        const nombreCompleto = `${el.perfil.papellido} ${
          el.perfil.sapellido ?? ''
        } ${el.perfil.pnombre} ${el.perfil.snombre ?? ''}`;
        const dni = `${el.perfil.tipoDni}-${formatDNI(el.perfil.dni)}`;

        return {
          ...el,
          dni,
          nombre: {
            nombre: nombreCompleto,
            correo: el.correo,
          },
          rol: {
            rol: el.rol,
            admin: el.admin,
          },
          genero: generosEnum[el.perfil.genero],
          entidades,
          estatus: el.estatus.nombre,
          actions: el,
          foto: {
            nombre: el.perfil.pnombre,
            avatar: el.perfil.avatar,
          },
        };
      });

      setRows(lista);
    };
    fetchData();
  }, [usuariosStore.all]);

  // const _handleInfoClick = async (id) => {
  //     const user = usuariosStore.all.find(el => el.id === id);
  //     await setActivoUsuariosAction(dispatch, user)
  //     history.push(ROUTES.usuariosInfo.to);
  // }

  const _handleEditClick = async (id) => {
    const user = usuariosStore.all.find((el) => el.id === id);
    await setActivoUsuariosAction(dispatch, user);
    setOpenModalForm(true);
  };

  const _handleDeleteClick = async (id) => {
    setLoadingDelete(true);
    await deleteUsuariosAction({ dispatch, notify }, id, usuariosStore.params);
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.foto.name,
      label: CONST.foto.label,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ marginRight: '10px' }}>
              <Avatar
                alt={value.nombre}
                sx={{ width: 50, height: 50 }}
                src={getFilesArchivos(value.avatar)}
              />
            </Box>
          );
        },
      },
    },
    {
      name: CONST.dni.name,
      label: CONST.dni.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '120px' }}>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value}
              </NameComponent>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: 'Nombres y apellidos',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
              <CopyToClipboard
                text={value.correo}
                onCopy={() => {
                  notify(`${value.correo} Copiado!`, {
                    vertical: 'bottom',
                  });
                }}
              >
                <Typography
                  variant="body1"
                  color="initial"
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '10px',
                    cursor: 'pointer',
                    '&:hover': {
                      color: blue[700],
                    },
                  }}
                >
                  {value.correo}
                </Typography>
              </CopyToClipboard>
            </>
          );
        },
      },
    },
    {
      name: CONST.rol.name,
      label: CONST.rol.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '120px' }}>
              <Chip
                size="small"
                label={`${rolesArray[value.rol]}${value.admin ? '-Admin' : ''}`}
                sx={{
                  color: 'white',
                  backgroundColor: rolColor({
                    rol: value.rol,
                    admin: value.admin,
                  }),
                }}
              />
            </Box>
          );
        },
      },
    },
    {
      name: CONST.entidades.name,
      label: CONST.entidades.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value.map((ent) => {
            return (
              <Stack
                direction="column"
                spacing={1}
                sx={{
                  border: '1px solid black',
                  m: 1,
                  p: 0.5,
                  borderRadius: 1,
                }}
              >
                <Typography sx={{ fontSize: '10pt' }}>
                  {ent.entidad.nombre}
                </Typography>

                {ent.perfiles.map((per) => {
                  return (
                    <Stack direction="row" spacing={1}>
                      <Chip size="small" label={per.nombre} />
                    </Stack>
                  );
                })}
              </Stack>
            );
          });
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={
                  value === 'ACTIVO'
                    ? 'success'
                    : value === 'BLOQUEADO'
                    ? 'error'
                    : 'warning'
                }
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '5vw' }}>
              <Stack direction="row">
                {usuariosStore.isAllOnEDU ? null : (
                  <BotonComponent
                    click={async () => {}}
                    icon
                    size="medium"
                    transparentBg
                    dashboardIcon
                    tooltip="Panel de gestión"
                  />
                )}
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onEdit={
                    usuariosStore.isAllOnEDU
                      ? null
                      : () => _handleEditClick(tableMeta.rowData[0])
                  }
                  onDelete={
                    loginStore.user.id === tableMeta.rowData[0]
                      ? null
                      : async () => {
                          await setActivoUsuariosAction(dispatch, value);
                          setOpenModalDelete(true);
                        }
                  }
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: usuariosStore.params.limit,
    count: usuariosStore.pagination.totalItems,
    page: usuariosStore.pagination.currentPage - 1,
    rowsPerPageOptions: [25, 50, 100, 150],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...usuariosStore.params,
            rol: null,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_USUARIOS, payload });
        }, 800);
      }
    },
    onSearchClose: () => {
      const payload = {
        ...usuariosStore.params,
        q: null,
        page: 1,
      };
      dispatch({ type: PARAMS_USUARIOS, payload });
    },
    onChangePage: async (currentPage) => {
      const payload = {
        ...usuariosStore.params,
        page: currentPage + 1,
      };
      dispatch({
        type: PARAMS_USUARIOS,
        payload,
      });
    },
    onChangeRowsPerPage: async (numberOfRows) => {
      const payload = {
        ...usuariosStore.params,
        limit: numberOfRows,
        page: 1,
      };
      dispatch({
        type: PARAMS_USUARIOS,
        payload,
      });
    },
    // customSearch: (q, currentRow, columns) => {
    //   q = q.toLowerCase();
    //   const data = usuariosStore.all.find(({ id }) => id === currentRow[0]);
    //   if (!data) return true;
    //   const userData = `${data.perfil.dni}
    //     ${data.correo}
    //     ${data.perfil.pnombre}
    //     ${data.perfil.papellido}
    //     ${data.rol}
    //     ${data.estatus.nombre}
    //     `.toLowerCase();
    //   return userData.includes(q);
    // },
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget isLoading={usuariosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={`Listado de ${usuariosStore.pagination.totalItems} registros`}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {usuariosStore.activo && (
        <ModalComponent
          id="modalDeleteMaterias"
          title={`Eliminar`}
          open={openModalDelete}
          maxWidth="sm"
          onClose={() => setOpenModalDelete(!openModalDelete)}
        >
          <Grid container spacing={1}>
            <Grid item md={12}>
              ¿Seguro que quieres eliminar este usuario?
              <br />
              <br />
              <Typography variant="h6">
                {usuariosStore.activo.perfil.pnombre}{' '}
                {usuariosStore.activo.perfil.papellido}
              </Typography>
            </Grid>
            <Grid item md={12} align="right">
              <Button
                color="error"
                variant="outlined"
                onClick={async () => {
                  await _handleDeleteClick(usuariosStore.activo.id);
                }}
                sx={{ mr: 2 }}
              >
                ELIMINAR
              </Button>
              <Button
                sx={{ color: BLUE_COLOR }}
                onClick={() => setOpenModalDelete(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        </ModalComponent>
      )}
    </Grid>
  );
};

export default ListadoUsuarios;
